import React, { Component } from "react";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  companyBlock: {
    marginBottom: "8pt",
  },
  companyLine: {
    margin: "2pt 0",
  },
  header: {
    marginBottom: "12pt",
    textAlign: "center",
  },
  title: {
    fontSize: "18pt",
    margin: "0 0 6pt",
  },
  headerLine: {
    margin: "3pt 0",
  },
  table: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    marginBottom: "10pt",
    width: "100%",
  },
  sectionHeader: {
    backgroundColor: "#d9d9d9",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "center",
  },
  columnHeader: {
    backgroundColor: "#e6e6e6",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "center",
    verticalAlign: "middle",
  },
  cell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    verticalAlign: "top",
  },
  centerCell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "center",
    verticalAlign: "top",
  },
  amountCell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  totalLabelCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
  },
  totalAmountCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
};

export default class RapprochementPDF extends Component {
  render() {
    // Totaux calculés par le formulaire (calculerTotaux) : ne pas les recalculer ici,
    // sinon l'édition diverge de l'écran (report, lignes de notation)
    const {
      lignesNonPointees,
      totalSoldeDebitC,
      totalSoldeCreditC,
      totalSoldeDebitP,
      totalSoldeCreditP,
      dateDu,
      dateAu,
      compteGeneral,
      soldeTheorique,
      comptes,
      societes,
    } = this.props;

    let totalDebitF = 0;
    let totalCreditF = 0;

    let totalSoldeDebitR = 0;
    // let totalSoldeCreditR = 0;

    return (
      <div style={styles.document}>
        <div style={styles.companyBlock}>
          <p style={styles.companyLine}>
            <strong>{societes[0].societe_raison_sociale}</strong>
          </p>
          <p style={styles.companyLine}>
            {societes[0].societe_adresse.adresse_numero} {societes[0].societe_adresse.adresse_voie}
          </p>
          <p style={styles.companyLine}>{societes[0].societe_adresse.adresse_secteur}</p>
          <p style={styles.companyLine}>
            {societes[0].societe_adresse.adresse_code_postal}{" "}
            {societes[0].societe_adresse.adresse_ville}
          </p>
        </div>

        <div style={styles.header}>
          <h1 style={styles.title}>Rapprochement bancaire</h1>
          <p style={styles.headerLine}>
            <span>
              <strong>
                {`Situation ${
                  dateDu ? "du " + dateDu.format("DD/MM/YYYY") + " " : ""
                }au ${dateAu.format("DD/MM/YYYY")}`}
              </strong>
            </span>
          </p>
          <p style={styles.headerLine}>
            <strong>
              Compte{" "}
              {comptes.find((compte) => compte.compte_id === compteGeneral).compte_compte_general}
              {" - "}
              {comptes.find((compte) => compte.compte_id === compteGeneral).compte_libelle}
            </strong>
          </p>
        </div>

        <table style={styles.table}>
          <thead>
            <tr>
              <th colSpan="4" style={styles.sectionHeader}>
                <strong>ECRITURES EN ATTENTE DE RAPPROCHEMENT</strong>
              </th>
            </tr>
            <tr>
              <th width="12%" scope="col" style={styles.columnHeader}>
                <strong>DATE</strong>
              </th>
              <th width="58%" scope="col" style={styles.columnHeader}>
                <strong>LIBELLE</strong>
              </th>
              <th width="15%" scope="col" style={styles.columnHeader}>
                <strong>DEBIT</strong>
              </th>
              <th width="15%" scope="col" style={styles.columnHeader}>
                <strong>CREDIT</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            {lignesNonPointees.map((ecriture, i) => {
              totalDebitF += parseFloat(ecriture.ecriture_ligne_montant_debit);
              totalCreditF += parseFloat(ecriture.ecriture_ligne_montant_credit);

              return (
                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#eeeeee" }}>
                  <td width="12%" style={styles.centerCell}>
                    {ecriture.ecriture_date_ecriture}
                  </td>
                  <td width="58%" style={styles.cell}>
                    {ecriture.ecriture_ligne_libelle}
                  </td>
                  <td width="15%" style={styles.amountCell}>
                    {parseFloat(ecriture.ecriture_ligne_montant_debit) !== 0 ? (
                      parseFloat(ecriture.ecriture_ligne_montant_debit).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })
                    ) : (
                      <></>
                    )}
                  </td>
                  <td width="15%" style={styles.amountCell}>
                    {parseFloat(ecriture.ecriture_ligne_montant_credit) !== 0 ? (
                      parseFloat(ecriture.ecriture_ligne_montant_credit).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })
                    ) : (
                      <></>
                    )}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td colSpan="2" width="70%" style={styles.totalLabelCell}>
                <strong>TOTAL</strong>
              </td>
              <td width="15%" style={styles.totalAmountCell}>
                {parseFloat(totalDebitF).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
              <td width="15%" style={styles.totalAmountCell}>
                {parseFloat(totalCreditF).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
            </tr>
          </tbody>
        </table>

        <table style={styles.table}>
          <tbody>
            <tr>
              <td colSpan="2" width="70%" style={styles.totalLabelCell}>
                <strong>SOLDE dans la comptabilité au {dateAu.format("DD/MM/YYYY")}</strong>
              </td>
              <td width="15%" style={styles.totalAmountCell}>
                {parseFloat(totalSoldeDebitC).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
              <td width="15%" style={styles.totalAmountCell}>
                {parseFloat(totalSoldeCreditC).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
            </tr>
            <tr>
              <td colSpan="2" width="70%" style={styles.totalLabelCell}>
                <strong>SOLDE du relevé de banque au {dateAu.format("DD/MM/YYYY")}</strong>
              </td>
              <td width="15%" style={styles.totalAmountCell}>
                {parseFloat(totalSoldeDebitR).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
              <td width="15%" style={styles.totalAmountCell}>
                {parseFloat(soldeTheorique).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
            </tr>
            <tr>
              <td colSpan="2" width="70%" style={styles.totalLabelCell}>
                <strong>ECART rapprochement</strong>
              </td>
              <td width="15%" style={styles.totalAmountCell}>
                {parseFloat(totalSoldeDebitP).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
              <td width="15%" style={styles.totalAmountCell}>
                {parseFloat(totalSoldeCreditP).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
